import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, FormGroup,
    Label, Input, Button, Row, Col
} from 'reactstrap';

import { CursoContext } from '../../context/CursoContext';
import { EditCursoType } from '../../context/hooks/useCurso';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    cursoData: EditCursoType;     
    onCursoAtualizado: () => void;
}

export const EditCursoModal: React.FC<Props> = ({
    isOpen,
    toggle,
    cursoData,
    onCursoAtualizado
}) => {
    const { updateCurso } = useContext(CursoContext);
    const [form, setForm] = useState<EditCursoType>(cursoData);

    useEffect(() => { if (isOpen) setForm(cursoData); }, [isOpen, cursoData]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) =>
        setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const ok = await updateCurso(form);
        if (ok) {
            onCursoAtualizado();
            toggle();
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Alterar informações do curso</ModalHeader>

            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="name">Nome</Label>
                                <Input
                                    className="form-control-alternative"
                                    id="name"
                                    name="name"
                                    placeholder="Nome do curso"
                                    value={form.name}
                                    onChange={handleChange}
                                    required
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="d-flex justify-content-end">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">
                            Salvar alterações
                        </Button>
                        <Button
                            style={{ background: '#d9534f', color: '#fff' }}
                            className="ml-2"
                            onClick={toggle}
                        >
                            Cancelar
                        </Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default EditCursoModal;